module.exports = __webpack_public_path__ + "img/602x698 Parcel.8c1fd945.jpg";